
export const FETCH_NOTIFICATION_REQUEST = 'FETCH_NOTIFICATION_REQUEST';
export const FETCH_NOTIFICATION_SUCCESS = 'FETCH_NOTIFICATION_SUCCESS';
export const FETCH_NOTIFICATION_FAILURE = 'FETCH_NOTIFICATION_FAILURE';
export const UPDATE_NOTIFCATION_REQUEST = 'UPDATE_NOTIFCATION_REQUEST';
export const UPDATE_NOTIFCATION_SUCCESS = 'UPDATE_NOTIFCATION_SUCCESS';
export const UPDATE_NOTIFCATION_FAILURE = 'UPDATE_NOTIFCATION_FAILURE';


export const fetchNotifications = () => ({
    type: FETCH_NOTIFICATION_REQUEST
  });
 

  export const updatenotification = (notificationId) => ({
    type: UPDATE_NOTIFCATION_REQUEST,
    payload : notificationId
  });